import { useSelector } from 'react-redux';
import { selectFragno1 } from '../reducers/fragno1';

// Whether this page load renders the Fragno 1 variants, as resolved at boot.
const useFragno1 = () => useSelector(selectFragno1);

export default useFragno1;
